// extracted by mini-css-extract-plugin
module.exports = {"inputSearch":"Header_inputSearch__cydjG","nav":"Header_nav__3xJxL"};